import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { getUserDetail } from "../../utils/helper";
import { profilePostAction } from "../../actions/profileAction";
import FormikControl from "../../components/WraapperComponent/FormikControl";
import TwoFAModal from "../../components/TwoFAModal";

const LoginTwoFAPage = () => {
  const appLoading = useSelector((state) => state.alert.appLoading);
  const dispatch = useDispatch();
  const formikRef = useRef(null);
  const codeInputRef = useRef(null); // Ref for the verification code input
  const [localData, setLocalData] = useState(null);
  const [showTwoFAModal, setShowTwoFAModal] = useState(false);

  const initialValues = {
    code: "",
  };

  const validationSchema = Yup.object({
    code: Yup.string().nullable().required("Verification code is required"),
  });

  const onSubmit = (values) => {
    const params = {
      token: localData?.token,
      action: "verifyLoginCode",
      data: {
        otpCode: values.code,
      },
    };

    dispatch(
      profilePostAction(
        {
          params,
        },
        (status) => {
          if (status) {
            localStorage.setItem("userDetail", JSON.stringify(localData));
            window.location.href = "/";
          }
        }
      )
    );
  };

  useEffect(() => {
    let localData = getUserDetail();
    setLocalData(localData);
    localStorage.clear();

    // Focus on the verification code input when the component mounts
    if (codeInputRef.current) {
      codeInputRef.current.focus();
    }
  }, []);

  return (
    <div className="login-container">
      {showTwoFAModal && (
        <TwoFAModal
          closePopup={() => setShowTwoFAModal(false)}
          fromLogin={true}
          localData={localData}
        />
      )}
      <h2 className="login-title">Two-Factor Authentication</h2>
      <div className="fa-form">
        <p className="page-desc">
          Enter the code from your authenticator application.
        </p>
        <Formik
          innerRef={formikRef}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ errors, touched }) => (
            <Form>
              <div>
                <FormikControl
                  control="input"
                  type="text"
                  label="Verification Code"
                  placeholder="Enter verification code"
                  name="code"
                  hasError={errors.code && touched.code}
                  innerRef={codeInputRef} // Attach ref here
                />
              </div>

              <div className="submit-section d-flex items-center">
                <button
                  className="btn-orange"
                  type="submit"
                  disabled={appLoading}
                >
                  Verify
                </button>
                <p
                  onClick={() => setShowTwoFAModal(true)}
                  className="link-orange"
                  style={{
                    cursor: "pointer",
                    marginBottom: 0,
                    marginTop: "6px",
                  }}
                >
                  Reset 2FA code?
                </p>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default LoginTwoFAPage;
